import React, { Component } from 'react';
import Modal from 'react-awesome-modal';
import { connect } from 'react-redux';
import _ from 'lodash';

import PageHeader from '../../../shared/page-header/components/page-header';
import CloseBtn from '../../../shared/close-btn/components/close-btn';
import RadioButtonGroup from '../../../shared/radio-button-group/components/radio-button-group';
import Button from '../../../shared/button/components/button';
import { toggleChooseCampaignModal, toggleCreateCampaignModal, toggleMobileCampaignModal } from '../actions/campaigns-actions';
import { toggleInfoModal } from '../../../shared/info-modal/actions/info-modal-actions';
import campaignConstants from '../constants/campaigns-constants';
import constants from '../../../../common/constants';

class ChooseCampaignModal extends Component {
  state = {
    campaignType: 'web',
  };

  closeModal() {
    const { toggleChooseCampaignModal } = this.props;

    toggleChooseCampaignModal(false);
  }

  onTypeStatus(value) {
    this.setState({ campaignType: value });
  }

  chooseCampaignType() {
    const { toggleCreateCampaignModal, toggleMobileCampaignModal, toggleInfoModal } = this.props;
    const { campaignType } = this.state;

    this.closeModal();

    if (campaignType === campaignConstants.campaign_types.web.value) {
      toggleCreateCampaignModal(true);
    } else {
      if (constants.is_prod_env) {
        toggleInfoModal(true, constants.info_modal_types.info.value, 'CAMPAIGNS.INSTALL_LINK_MESSAGE');
      } else {
        // TODO: for now on dev there is still feature fo requesting install link, on prod just info message
        toggleMobileCampaignModal(true);
      }
    }
  }

  render() {
    const { showChooseCampaignModal } = this.props;
    const { campaignType } = this.state;
    const campaignTypes = _.values(campaignConstants.campaign_types);

    return (
      <Modal visible={showChooseCampaignModal} effect="fadeInUp" onClickAway={() => this.closeModal()}>
        <div className="default-modal">
          <CloseBtn callback={this.closeModal.bind(this)} />
          <div className="text-center">
            <PageHeader title={'CAMPAIGNS.CHOOSE_CAMPAIGN_TITLE'} />
          </div>
          <div className="row">
            <div className="m-b-20">
              <RadioButtonGroup value={campaignType} options={campaignTypes} label={'CAMPAIGNS.CHOOSE_CAMPAIGN_TYPE'} onChange={this.onTypeStatus.bind(this)} />
            </div>
            <div className="row">
              <div className="col-sm-6 col-xs-12">
                <Button label={'COMMON.CLOSE'} customClass={`m-t-20`} onClick={() => this.closeModal()} />
              </div>
              <div className="col-sm-6 col-xs-12">
                <Button label={'COMMON.NEXT'} disabled={!campaignType} customClass={`affiliate-btn-red m-t-20`} onClick={() => this.chooseCampaignType()} />
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  showChooseCampaignModal: state.campaignsReducer.showChooseCampaignModal,
});

const mapDispatchToProps = dispatch => ({
  toggleChooseCampaignModal: show => {
    dispatch(toggleChooseCampaignModal(show));
  },
  toggleCreateCampaignModal: (show, link) => {
    dispatch(toggleCreateCampaignModal(show, link));
  },
  toggleMobileCampaignModal: show => {
    dispatch(toggleMobileCampaignModal(show));
  },
  toggleInfoModal: (show, type, message, translations, callback, path, btnText) => {
    dispatch(toggleInfoModal(show, type, message, translations, callback, path, btnText));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ChooseCampaignModal);



// WEBPACK FOOTER //
// ./src/app/main/campaigns/components/choose-campaign-modal.js